module.exports = __webpack_public_path__ + "img/2486d69.png";